import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Modal,
  Tooltip,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import PublicApiServices from "../../services/PublicApiServices";
import "./SignInWidget.css";
import {
  MASTER_DATA,
  REUSABLE_LINK_ACTION,
  REUSABLE_LINK_FORM,
} from "../../constants/api-constants";
import { useLoading } from "../../hooks/useLoader";
import XFDLViewer from "../../common/XFDLViewer/XFDLViewer";
import { execeptionMessage } from "../../constants/common";
import "./Share.css";
import { MandatoryField } from "../../common/MandatoryFieldsIcon/MandatoryField";
import { useFormik } from "formik";
import { ReusableLinkSchema } from "../../common/ValidationSchema/ValidationSchema";
import InlineMessage from "../../common/InlineMessage/InlineMessage";
import ConfirmationWithReason from "../../common/ConfirmationWithReason/ConfirmationWithReason";
import { AudioPreview } from "../../common/AudioPreview/AudioPreview";
import { VideoPreview } from "../../common/VideoPreview/VideoPreview";
import MemoizedDocumentViewer from "./MemoizedDocViewer";
import Group2252459 from "../../common/Modal/Distributor/Group2252459.png";
import SearchableDropDown from "../../common/SearchableDropDown/SearchableDropdown";
import ApiServices from "../../services/ApiServices";
import {
  getBillingZipLabel,
  getBillingZipPlaceholder,
  getMaxLength,
  isCountryCanada,
} from "../../utilities/common";
import CompanyTypeDropdown from "../../common/RadioButtonDropdown/RadioButtonDropdown";
import {
  DEFAULT_META_DESCRIPTION,
  getAgencyDescription,
  getDocumentTitle,
} from "../../utilities/documentTitle";

/*istanbul ignore next */

function ReusableLink() {
  const { id } = useParams();
  const history = useHistory();
  const { showLoader } = useLoading();
  const [linkValidated, setLinkValidated] = useState(false);
  const [linkValidationError, setLinkValidationError] = useState("");
  const [result, setResult] = useState(null);
  const [resultList, setResultList] = useState([]);
  const [docIndex, setDocIndex] = useState(null);
  const [xfdlCurrentJson, setXfdlCurrentJson] = useState(null);
  const [token] = useState(null);
  const [isInValid, setIsInValid] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(
    () => sessionStorage.getItem(`reusableLinkSubmitted_${id}`) === "1",
  );
  const [showAdditionalNotes, setShowAdditionalNotes] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState([]);
  const [showAllAdditionalNotes, setShowAllAdditionalNotes] = useState(false);
  const [allAdditionalNotes, setAllAdditionalNotes] = useState([]);
  const [totalRemainingMandatoryFields, setTotalRemainingMandatoryFields] =
    useState(0);
  const [countryOptions, setCountryOptions] = useState([]);
  const [allStateOptions, setAllStateOptions] = useState([]);
  const [folderType, setFolderType] = useState([]);
  const [folderName, setFolderName] = useState(null);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      streetAddress1: "",
      streetAddress2: "",
      countryId: 1,
      stateId: "",
      city: "",
      zipCode: "",
      phone: "",
      mobile: "",
      email: "",
      businessName: "",
      companyType: "",
      dba: "",
    },
    enableReinitialize: true,
    validationSchema: ReusableLinkSchema,
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 616,
    bgcolor: "#FFFFFF",
    boxShadow: 24,
    p: 4,
  };

  const commonInvalid =
    !formik.isValid ||
    totalRemainingMandatoryFields > 0 ||
    !formik.values.streetAddress1 ||
    !formik.values.city ||
    !formik.values.stateId ||
    !formik.values.zipCode ||
    !formik.values.countryId ||
    !formik.values.email ||
    !formik.values.phone;

  let folderTypeInvalid = false;
  if (Number(folderType) === 1) {
    folderTypeInvalid = !formik.values.firstName || !formik.values.lastName;
  } else if (Number(folderType) === 2) {
    folderTypeInvalid =
      !formik.values.businessName || !formik.values.companyType;
  }

  const handleFieldMapping = (fieldName, value) => {
    formik.setFieldValue(fieldName, value);
    let updatedResults = [...resultList];
    const fieldMappings = {
      firstName: "NamedInsured_FullName",
      lastName: "NamedInsured_FullName",
      streetAddress1: "NamedInsured_MailingAddress_LineOne",
      streetAddress2: "NamedInsured_MailingAddress_LineTwo",
      city: "NamedInsured_MailingAddress_CityName",
      stateId: "NamedInsured_MailingAddress_StateOrProvinceCode",
      zipCode: "NamedInsured_MailingAddress_PostalCode",
      phone: "NamedInsured_Primary_PhoneNumber",
      email: "NamedInsured_ContactPerson_Email",
      businessName: "NamedInsured_FullName",
    };
    const updateFullName = (item) => {
      const sfirstName =
        fieldName === "firstName" ? value : formik.values.firstName || "";
      const lastName =
        fieldName === "lastName" ? value : formik.values.lastName || "";
      const fullName = `${sfirstName} ${lastName}`.trim();
      updateMappedFieldsStartingWith(item, "NamedInsured_FullName_A", fullName);
    };
    const updateCompanyName = (item) => {
      updateMappedFieldsStartingWith(item, "NamedInsured_FullName_A", value);
    };
    const updateStateName = (item) => {
      const state = allStateOptions.find((s) => s.stateId === value);
      const stateName = state?.name || "";
      updateMappedFieldsStartingWith(item, fieldMappings[fieldName], stateName);
    };
    const updateField = (item) => {
      updateMappedFieldsStartingWith(item, fieldMappings[fieldName], value);
    };
    updatedResults.forEach((item) => {
      if (fieldName === "firstName" || fieldName === "lastName") {
        updateFullName(item);
      } else if (fieldName === "businessName") {
        updateCompanyName(item);
      } else if (fieldName === "stateId") {
        updateStateName(item);
      } else if (fieldMappings[fieldName]) {
        updateField(item);
      }
    });
    setResultList(updatedResults);
    checkRequiredFields();
  };

  const updateMappedFieldsStartingWith = (item, pattern, value) => {
    const updateExistingFormData = newFunction_1(item, pattern, value);

    const findMatchingFormData = () => {
      return item.formData?.some((el) => el.key.startsWith(pattern));
    };

    const extractFieldNamesFromCanvas = () => {
      return newFunction(pattern, item);
    };

    if (findMatchingFormData()) {
      updateExistingFormData();
    } else {
      const newFields = extractFieldNamesFromCanvas();
      newFields.forEach((fieldName) => {
        item.formData = [...item.formData, { key: fieldName, value }];
      });
    }
  };

  const containerWidth = xfdlCurrentJson?.FormViewSize
    ? `${Number(xfdlCurrentJson.FormViewSize) + 30}px`
    : "100%";
  const agencyName =
    resultList
      .find((item) => item?.reusableLinkContentId === docIndex)
      ?.formData?.find((field) => field?.key === "Producer_FullName_A")
      ?.value?.trim() || "";

  const fetchReusableLinkContent = async (reusableLinkContentId = 0) => {
    try {
      showLoader(true);
      setLinkValidationError("");
      const response = await getReusableLinkFormData(id, reusableLinkContentId);
      if (response?.responseStatus?.isSuccess) {
        handleSuccessResponse(response, reusableLinkContentId);
      } else {
        handleErrorResponse(response.responseStatus.error);
      }
    } catch (e) {
      handleException();
    } finally {
      showLoader(false);
    }
  };

  const loadData = async () => {
    await loadDropdownOptions();
    await fetchReusableLinkContent(0);
  };

  const getReusableLinkFormData = async (id, contentId) => {
    try {
      const response = await PublicApiServices.httpGet(
        `${REUSABLE_LINK_FORM}/${id}/${contentId}`,
      );
      if (response?.responseStatus?.isSuccess) {
        setFolderType(response.result.folderType);
        setFolderName(response.result.folderName);
      } else {
        const errorMessage = response?.responseStatus?.error;
        toast.error(errorMessage);
      }
      return response;
    } catch (error) {
      console.error("Error fetching reusable link form data:", error);
      toast.error("Unable to fetch reusable link data.");
      return null;
    }
  };

  const handleSuccessResponse = (response, reusableLinkContentId) => {
    if (reusableLinkContentId === 0) {
      setLinkValidated(true);
    }
    const contents = response.result?.contents || [];
    if (contents.length === 0) return;
    const sortedContents = prepareContents(contents);
    handleContentLevelFirst(sortedContents, reusableLinkContentId);
    const currentContent =
      sortedContents.find(
        (x) => x.reusableLinkContentId === reusableLinkContentId,
      ) || sortedContents[0];

    setDocIndex(currentContent.reusableLinkContentId);
    initializeFormDetails(currentContent);
  };

  const prepareContents = (contents) => {
    return contents
      .sort((a, b) => a.reusableLinkContentId - b.reusableLinkContentId)
      .map((item) => ({
        ...item,
        xfdlJson: item.xfdlJson ? JSON.parse(item.xfdlJson) : null,
      }));
  };

  const handleErrorResponse = (error) => {
    setLinkValidationError(error);
  };
  const handleException = () => {
    setLinkValidationError(execeptionMessage);
    toast.error(execeptionMessage);
  };

  const saveOrSubmit = (isSubmit) => {
    if (isSubmit) {
      let notes = resultList
        .filter((x) => x.additionalNotes)
        ?.map((item) => {
          return {
            additionalNotes: item.additionalNotes,
            reusableLinkContentId: Number(item.reusableLinkContentId),
            uniqueId: Math.floor(Math.random() * 1000),
          };
        });
      setAllAdditionalNotes(notes);
      setShowAllAdditionalNotes(true);
    } else {
      apiHandler(isSubmit);
    }
  };

  const apiHandler = async (isSubmit, allAdditionalNotesLocal = []) => {
    try {
      showLoader(true);
      let payload = {
        isSubmit: isSubmit,
        firstName: formik.values.firstName,
        lastName: formik.values.lastName,
        businessName: formik.values.businessName,
        dba: formik.values.dba,
        streetAddress1: formik.values.streetAddress1,
        streetAddress2: formik.values.streetAddress2,
        countryId: formik.values.countryId,
        stateId: formik.values.stateId,
        city: formik.values.city,
        zipCode: formik.values.zipCode,
        phone: formik.values.phone,
        mobile: formik.values.mobile,
        email: formik.values.email,
        companyType: formik.values.companyType,
        linkCode: `${id}`,
        contents: resultList.map((item) => {
          return {
            additionalNotes: allAdditionalNotesLocal.find(
              (x) => x.reusableLinkContentId === item.reusableLinkContentId,
            )?.additionalNotes,
            contentId: item.contentId,
            reusableLinkContentId: item.reusableLinkContentId,
            usersFormData: item.formData,
          };
        }),
        token: token,
      };
      const response = await PublicApiServices.httpPost(
        REUSABLE_LINK_ACTION,
        payload,
      );
      if (response?.responseStatus?.isSuccess) {
        setShowAllAdditionalNotes(false);
        showLoader(false);
        if (isSubmit) {
          setIsSubmitted(true);
          setIsInValid(true);
          sessionStorage.setItem(`reusableLinkSubmitted_${id}`, "1");
          sessionStorage.setItem(
            "lastReusableLinkPath",
            `/reusable-link/${id}`,
          );
          history.replace("/success", { fromFormSubmission: true });
          return;
        }
        toast.success(response.responseStatus.description);
      } else {
        toast.error(response.responseStatus.error);
      }
      showLoader(false);
      if (isSubmit) {
        setIsSubmitted(true);
        setIsInValid(true);
      }
    } catch (e) {
      showLoader(false);
    }
  };

  const filteredStateOptions = () => {
    return formik.values.countryId
      ? allStateOptions
          .filter((s) => s.countryId === formik.values.countryId)
          .map((s) => ({
            label: s.name,
            value: s.stateId,
          }))
      : [];
  };

  const getSelectedOption = (options, value) => {
    if (!value) return [];
    const selected = options.find((opt) => opt.value === value);
    return selected ? [selected] : [];
  };

  const handleCountryChange = (val) => {
    const selected = Array.isArray(val) ? val[0] : val;
    const newCountry = selected?.value || "";
    formik.setValues({
      ...formik.values,
      countryId: newCountry,
      dirty: true,
      stateId: "",
    });
  };

  const handleStateChange = (val) => {
    const selected = Array.isArray(val) ? val[0] : val;
    const stateValue = selected?.value || "";
    formik.setFieldValue("stateId", stateValue);
    handleFieldMapping("stateId", stateValue);
  };

  const countryDropdownOptions = countryOptions.length
    ? countryOptions
    : [{ label: "Loading...", value: "" }];

  const selectedCountry = getSelectedOption(
    countryOptions,
    formik.values.countryId,
  );
  const selectedState = getSelectedOption(
    filteredStateOptions(),
    formik.values.stateId,
  );

  const changeHandler = (event, itemName, isRequired) => {
    let results = [...resultList];
    results.forEach((item) => {
      let value = item.formData?.filter((el) => el.key === itemName);
      if (value?.length > 0) {
        item.formData.forEach((item) => {
          if (item.key === itemName) {
            item.value = event.target.value;
          }
        });
      } else {
        item.formData = [
          ...item.formData,
          { key: itemName, value: event.target.value },
        ];
      }
    });
    setResultList(results);
    checkRequiredFields();
  };

  const checkBoxHandler = (event, itemName, isRequired) => {
    let results = [...resultList];
    results.forEach((item) => {
      let value = item.formData?.filter((el) => el.key === itemName);
      if (value?.length > 0) {
        item.formData.forEach((item) => {
          if (item.key === itemName) {
            item.value = event.target.checked ? "true" : "false";
          }
        });
      } else {
        item.formData = [
          ...item.formData,
          { key: itemName, value: event.target.checked ? "true" : "false" },
        ];
      }
    });
    setResultList(results);
    checkRequiredFields();
  };
  const changeSubmitNotesHandler = (
    uniqueId,
    additionalNotes = "",
    newId = 0,
  ) => {
    let results = [...allAdditionalNotes];
    results.forEach((item) => {
      if (item.uniqueId === uniqueId) {
        item.additionalNotes = additionalNotes;
        item.reusableLinkContentId = Number(newId);
      }
    });
    setAllAdditionalNotes(results);
  };
  const checkRequiredFields = (resultListInput = null) => {
    let results = resultListInput ? [...resultListInput] : resultList;
    let invalid = results.length < 1;
    let totolManReqFieldCount = 0;
    results.forEach((item) => {
      if (item.xfdlJson?.Canvas?.length > 0) {
        item.requiredFeilds = checkIfRequiredFieldExist(
          item.xfdlJson,
          item.requiredFeilds,
        );
      } else {
        item.requiredFeilds = [];
      }
      item.MandatoryReqFieldCount = 0;
      for (const reqField of item.requiredFeilds) {
        const matchingField = item.formData.find(
          (field) => field.key === reqField.key,
        );
        if (
          !matchingField ||
          matchingField.value.trim() === "" ||
          matchingField.value === "false"
        ) {
          invalid = true;
          item.MandatoryReqFieldCount++;
        }
      }
      totolManReqFieldCount += item.MandatoryReqFieldCount;
    });
    setTotalRemainingMandatoryFields(totolManReqFieldCount);
    if (!xfdlCurrentJson) {
      invalid = false;
    }
    setIsInValid(invalid);
  };

  const loadDropdownOptions = async () => {
    showLoader(true);
    const url = `${MASTER_DATA}?include=countries&include=states`;
    const response = await ApiServices.httpGet(url);
    showLoader(false);
    const countries = response.result.countries.map((c) => ({
      label: c.name,
      value: c.countryId,
    }));
    setCountryOptions(countries);
    const statesByCountry = {};
    response.result.states.forEach((s) => {
      const countryKey = s.countryId;
      if (!statesByCountry[countryKey]) {
        statesByCountry[countryKey] = [];
      }
      statesByCountry[countryKey].push({
        label: s.name,
        value: s.stateId,
      });
    });
    setAllStateOptions(
      Array.isArray(response.result?.states) ? response.result.states : [],
    );
    const defaultCountry = countries.find(
      (c) => c.label.toLowerCase() === "usa" || c.isDefault,
    );
    if (defaultCountry) {
      formik.setFieldValue("country", defaultCountry.value);
      formik.setFieldValue("state", "");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    document.title = getDocumentTitle(`/reusable-link/${id}`, agencyName);
    const descriptions = document.querySelectorAll(
      'meta[name="description"], meta[property="og:description"]',
    );
    descriptions.forEach((meta) => {
      meta.setAttribute("content", getAgencyDescription(agencyName));
    });

    return () => {
      descriptions.forEach((meta) => {
        meta.setAttribute("content", DEFAULT_META_DESCRIPTION);
      });
    };
  }, [id, agencyName]);

  const fieldExistsInSection = (section, requriredFieldsValue) => {
    let fields = [];
    for (const requiredField of requriredFieldsValue) {
      if (
        section?.TextBoxes.some((field) => field.Name === requiredField.key)
      ) {
        fields.push(requiredField);
      }
      if (
        section?.CheckBoxes.some((field) => field.Name === requiredField.key)
      ) {
        fields.push(requiredField);
      }
    }
    return fields;
  };
  const changeNotesHandler = (additionalNotes) => {
    let results = [...resultList];
    results.forEach((item) => {
      if (item.reusableLinkContentId === docIndex) {
        item.additionalNotes = additionalNotes;
      }
    });
    setResultList(results);
    setShowAdditionalNotes(false);
  };

  const checkIfRequiredFieldExist = (xfdlJsonValue, requriredFieldsValue) => {
    let totalPages = xfdlJsonValue.TotalPages;
    let newRequiredFields = new Set();
    for (let i = 0; i <= totalPages; i++) {
      let newFieldValue = fieldExistsInSection(
        xfdlJsonValue.Canvas[i],
        requriredFieldsValue,
      );
      if (newFieldValue?.length > 0) {
        for (const field of newFieldValue) {
          newRequiredFields.add(field);
        }
      }
    }
    const array = Array.from(newRequiredFields);
    return array;
  };

  return (
    <>
      {linkValidated ? (
        loadPage()
      ) : (
        <div className="myContainer-link">
          <Container maxWidth="md" className="main-grid-container">
            <Grid container justifyContent="center" className="invalid-links">
              <Grid item xs={7} md={7} className="login-form ">
                <div className="signup-container invalid-link">
                  <Grid item xs={12} m={2}>
                    {linkValidationError}
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      )}
    </>
  );

  function initializeFormDetails(formDetails) {
    setResult(formDetails);
    setXfdlCurrentJson(formDetails.xfdlJson);
    const fileTypeMap = {
      1: "pdf",
      3: "jpg",
      4: "docx",
      5: "xlsx",
      6: "pptx",
      7: "mp3",
      8: "gif",
      9: "png",
      10: "mp4",
    };
    if (formDetails.gcpFilePath && fileTypeMap[formDetails.typeOfContent]) {
      setSelectedDocument([
        {
          uri: formDetails.gcpFilePath,
          fileName: formDetails.contentName,
          fileType: fileTypeMap[formDetails.typeOfContent],
        },
      ]);
    } else {
      setSelectedDocument([]);
    }
  }

  function handleContentLevelFirst(results, reusableLinkContentId) {
    let newresult = [...resultList];
    if (reusableLinkContentId === 0) {
      newresult = results;
    } else {
      let currentRecord = results.find(
        (x) => x.reusableLinkContentId === reusableLinkContentId,
      );
      newresult.forEach((item, index) => {
        if (item.reusableLinkContentId === reusableLinkContentId) {
          newresult[index] = {
            ...item,
            ...currentRecord,
            formData: item.formData?.length
              ? item.formData
              : currentRecord.formData,
            usersFormData: item.usersFormData ?? currentRecord.usersFormData,
          };
        }
      });
    }
    newresult.forEach((selectedShare) => {
      if (selectedShare.usersFormData?.length > 0) {
        const uniqueKeysMap = new Map();
        for (const item of selectedShare.usersFormData) {
          uniqueKeysMap.set(item.key, item.value);
        }
        const filteredFormData = selectedShare.formData.filter(
          (item) => !uniqueKeysMap.has(item.key),
        );
        const mergedFormData = filteredFormData.concat(
          selectedShare.usersFormData,
        );
        selectedShare.formData = mergedFormData;
      }
    });
    setResultList(newresult);
    checkRequiredFields(newresult);
  }

  function loadPage() {
    return (
      <Container
        maxWidth="md"
        className="width-container-share"
        style={{ width: containerWidth }}
      >
        <Grid item xs={12} pt={2} className="Grid-div-share">
          <div className="btns-share-xfdl-down">
            {
              <Button
                disabled={isSubmitted}
                variant="contained"
                onClick={() => {
                  window.location.reload();
                }}
                className="button-mrgin-share"
              >
                Reset
              </Button>
            }
            {
              <Button
                variant="contained"
                onClick={() => {
                  if (!navigator.onLine) {
                    toast.error(
                      "You are offline. Please reconnect to the internet and try again.",
                    );
                    return;
                  }
                  saveOrSubmit(true);
                }}
                disabled={commonInvalid || folderTypeInvalid}
                className="button-mrgin-share"
              >
                Submit
              </Button>
            }
          </div>

          {showAdditionalNotes && (
            <ConfirmationWithReason
              open={showAdditionalNotes}
              handleClose={() => setShowAdditionalNotes(false)}
              title="Notes"
              cancelButtonLabel="Cancel"
              confirmButtonLabel="Add"
              showReason={true}
              description={
                resultList.find((x) => x.reusableLinkContentId === docIndex)
                  ?.contentName
              }
              currentReason={
                resultList.find((x) => x.reusableLinkContentId === docIndex)
                  ?.additionalNotes || ""
              }
              onConfirm={(e, additionalNotes) => {
                changeNotesHandler(additionalNotes);
              }}
              onCancel={() => {
                setShowAdditionalNotes(false);
              }}
              placeholder="Enter Notes"
            />
          )}
          {showAllAdditionalNotes && (
            <Modal
              open={showAllAdditionalNotes}
              handleClose={() => {
                setShowAllAdditionalNotes(false);
              }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="confirmation-with-reason"
            >
              <Box sx={style}>
                <Grid container spacing={2} marginBottom={3}>
                  <Grid item xs={6}>
                    <Typography id="modal-modal-title" sx={{ mb: 2 }}>
                      Notes Summary
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    className="add-association-share top-right-actions"
                  >
                    {allAdditionalNotes?.length < resultList.length && (
                      <button
                        type="button"
                        name="add-icon"
                        title="add-icon"
                        className="add-itemz-font"
                        data-testid="AddAdditionalNote"
                        onClick={(e) => {
                          setAllAdditionalNotes((addNotes) => {
                            return [
                              ...addNotes,
                              {
                                additionalNotes: "",
                                reusableLinkContentId: 0,
                                uniqueId: Math.floor(Math.random() * 1000),
                              },
                            ];
                          });
                        }}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                        }}
                      >
                        <h5>
                          <span>+ Add Additional Note</span>
                        </h5>
                      </button>
                    )}
                  </Grid>
                </Grid>

                {allAdditionalNotes.map((item, index) => {
                  return (
                    <div
                      key={item.uniqueId}
                      className="reason-div"
                      style={{ marginTop: "10px" }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <select
                            id="selectSharedForm"
                            name="selectSharedForm"
                            value={item.reusableLinkContentId}
                            onChange={(e) => {
                              changeSubmitNotesHandler(
                                item.uniqueId,
                                item.additionalNotes,
                                e.target.value,
                              );
                            }}
                            className="form-control form-select"
                          >
                            <option selected="true" disabled="true" value={0}>
                              Select
                            </option>
                            {resultList
                              .filter((x) =>
                                filteredResultList(item, x, allAdditionalNotes),
                              )
                              ?.map((res) => {
                                return newFunction_3(res);
                              })}
                          </select>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          className="blue-field-section top-right-actions"
                        >
                          <IconButton
                            data-testid="btn-del"
                            aria-label="delete"
                            style={{ marginTop: "-10px" }}
                            color="primary"
                            onClick={() => {
                              newFunction_2(setAllAdditionalNotes, index);
                            }}
                          >
                            <img src={Group2252459} alt="Delete" height={35} />
                          </IconButton>
                        </Grid>
                      </Grid>
                      <TextField
                        multiline
                        value={item.additionalNotes}
                        className="reason-div-textfield"
                        data-testid="reason_textbox"
                        rows={3}
                        onChange={(e) => {
                          changeSubmitNotesHandler(
                            item.uniqueId,
                            e.target.value,
                            item.reusableLinkContentId,
                          );
                        }}
                        style={{ width: "100%", padding: 1 }}
                      />
                    </div>
                  );
                })}

                <div className="action-btn-div mt-4 action-popup-share">
                  <Button
                    className="action-button"
                    variant="outlined"
                    onClick={(e) => {
                      setShowAllAdditionalNotes(false);
                    }}
                    data-testid="cancel-action"
                  >
                    Cancel
                  </Button>
                  <Button
                    className="action-button ml-4"
                    variant="contained"
                    disabled={allAdditionalNotes.some(
                      (x) => x.reusableLinkContentId <= 0,
                    )}
                    onClick={(e) => {
                      apiHandler(true, allAdditionalNotes);
                    }}
                    data-testid="confirm-action"
                  >
                    Submit
                  </Button>
                </div>
              </Box>
            </Modal>
          )}
        </Grid>
        {resultList && (
          <Grid container className="select-share-xfdl" item xs={12}>
            {
              <Grid item xs={12}>
                <div>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Typography className="agency-name-align">
                      Agency Name:
                    </Typography>
                    <label htmlFor="sharedForm">
                      <span>{agencyName}</span>
                    </label>
                  </span>
                </div>
              </Grid>
            }
            {[1, 2].includes(
              resultList.find((x) => x.reusableLinkContentId === docIndex)
                ?.typeOfContent,
            ) && (
              <Grid item xs={12}>
                <div>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Typography className="agency-name-align">
                      Form Number :
                    </Typography>
                    <label htmlFor="sharedForm">
                      <span>
                        {
                          resultList.find(
                            (x) => x.reusableLinkContentId === docIndex,
                          )?.formNumber
                        }
                      </span>
                    </label>
                  </span>
                </div>
              </Grid>
            )}
            <Grid item xs={3}>
              <label htmlFor="sharedForm">
                <b>{folderName ?? "Forms"}</b>
              </label>
            </Grid>
          </Grid>
        )}

        {Number(folderType) === 2 ? (
          <Grid container className="select-share-xfdl" spacing={2} mt={2}>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Company Name
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.45}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter Company Name"
                  id="businessName"
                  name="businessName"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.businessName}
                  onChange={(e) =>
                    handleFieldMapping("businessName", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.businessName} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  DBA
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter DBA"
                  id="dba"
                  name="dba"
                  type="text"
                  maxLength={50}
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.dba}
                  onChange={(e) => handleFieldMapping("dba", e.target.value)}
                />
              </Grid>
              <InlineMessage error={formik.errors?.dba} />
            </Grid>
            <CompanyTypeDropdown
              formik={formik}
              handleFieldMapping={handleFieldMapping}
            />
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Street Address 1
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter Street Address 1"
                  id="streetAddress1"
                  name="streetAddress1"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.streetAddress1}
                  onChange={(e) =>
                    handleFieldMapping("streetAddress1", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.streetAddress1} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Street Address 2
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter Street Address 2"
                  id="streetAddress2"
                  name="streetAddress2"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.streetAddress2}
                  onChange={(e) =>
                    handleFieldMapping("streetAddress2", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.streetAddress2} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography className="agency-name-align-link">
                  Country <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <SearchableDropDown
                  id="country"
                  name="country"
                  placeholder="Select Country"
                  options={countryDropdownOptions}
                  value={selectedCountry}
                  setData={handleCountryChange}
                  className="form-label form-control custom-country-dropdown"
                  width="100%"
                />
                <InlineMessage error={formik.errors?.countryId} />
              </Grid>
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography className="agency-name-align-link">
                  State/Province <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <SearchableDropDown
                  key={`state-${formik.values?.countryId || "none"}`}
                  id="stateId"
                  name="stateId"
                  placeholder="Select State/Province"
                  options={filteredStateOptions()}
                  value={selectedState}
                  setData={handleStateChange}
                  isEditMode={true}
                  className="form-label form-control custom-country-dropdown"
                  width="100%"
                />
                <InlineMessage error={formik.errors?.stateId} />
              </Grid>
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  City
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter City"
                  id="city"
                  name="city"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.city}
                  onChange={(e) => handleFieldMapping("city", e.target.value)}
                />
              </Grid>
              <InlineMessage error={formik.errors?.city} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography htmlFor="zipCode">
                  {getBillingZipLabel(formik.values.countryId)}
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  id="zipCode"
                  name="zipCode"
                  className="form-label form-control"
                  type="text"
                  maxLength={getMaxLength(formik.values.countryId)}
                  placeholder={getBillingZipPlaceholder(
                    formik.values.countryId,
                  )}
                  value={formik.values.zipCode}
                  onChange={(e) => {
                    formik.setFieldValue("dirty", true);
                    const formattedValue = isCountryCanada(
                      formik.values.countryId,
                    )
                      ? formatCanadianPostalCode(e.target.value)
                      : formatUSZipCode(e.target.value);
                    formik.setFieldValue("zipCode", formattedValue);
                    handleFieldMapping("zipCode", formattedValue);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors.zipCode} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Business Phone
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <span
                  style={{
                    padding: "7.5px",
                    border: "1px solid #ccc",
                    backgroundColor: "#f8f9fa",
                    fontSize: "14px",
                  }}
                >
                  +1
                </span>
                <input
                  id="phone"
                  className="form-label form-control"
                  name="phone"
                  placeholder="Enter Business Phone"
                  maxLength={10}
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                  value={formik.values?.phone}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replaceAll(/\D/g, "");
                    formik.setFieldValue("dirty", true);
                    formik.setFieldValue("phone", onlyDigits);
                    handleFieldMapping("phone", onlyDigits);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors?.phone} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Mobile
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <span
                  style={{
                    padding: "7.5px",
                    border: "1px solid #ccc",
                    backgroundColor: "#f8f9fa",
                    fontSize: "14px",
                  }}
                >
                  +1
                </span>
                <input
                  id="mobile"
                  className="form-label form-control"
                  name="mobile"
                  placeholder="Enter Mobile"
                  maxLength={10}
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                  value={formik.values?.mobile}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replaceAll(/\D/g, "");
                    formik.setFieldValue("dirty", true);
                    formik.setFieldValue("mobile", onlyDigits);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors?.mobile} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Email
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                {" "}
                <input
                  id="email"
                  name="email"
                  className="form-label form-control"
                  type="email"
                  placeholder="Enter Email"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.email}
                  onChange={(e) => {
                    handleFieldMapping("email", e.target.value);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors?.email} />
            </Grid>
          </Grid>
        ) : (
          <Grid container className="select-share-xfdl" spacing={2} mt={2}>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  First Name
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.45}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter First Name"
                  id="firstName"
                  name="firstName"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.firstName}
                  onChange={(e) =>
                    handleFieldMapping("firstName", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.firstName} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Last Name
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.45}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter Last Name"
                  id="lastName"
                  name="lastName"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.lastName}
                  onChange={(e) =>
                    handleFieldMapping("lastName", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.lastName} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Street Address 1
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter Street Address 1"
                  id="streetAddress1"
                  name="streetAddress1"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.streetAddress1}
                  onChange={(e) =>
                    handleFieldMapping("streetAddress1", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.streetAddress1} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Street Address 2
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter Street Address 2"
                  id="streetAddress2"
                  name="streetAddress2"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.streetAddress2}
                  onChange={(e) =>
                    handleFieldMapping("streetAddress2", e.target.value)
                  }
                />
              </Grid>
              <InlineMessage error={formik.errors?.streetAddress2} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography className="agency-name-align-link">
                  Country <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <SearchableDropDown
                  id="country"
                  name="country"
                  placeholder="Select Country"
                  options={countryDropdownOptions}
                  value={selectedCountry}
                  setData={handleCountryChange}
                  className="form-label form-control custom-country-dropdown"
                  width="100%"
                />
                <InlineMessage error={formik.errors?.countryId} />
              </Grid>
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography className="agency-name-align-link">
                  State/Province <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <SearchableDropDown
                  key={`state-${formik.values?.countryId || "none"}`}
                  id="stateId"
                  name="stateId"
                  placeholder="Select State/Province"
                  options={filteredStateOptions()}
                  value={selectedState}
                  setData={handleStateChange}
                  isEditMode={true}
                  className="form-label form-control custom-country-dropdown"
                  width="100%"
                />
                <InlineMessage error={formik.errors?.stateId} />
              </Grid>
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  City
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  className="form-label form-control"
                  placeholder="Enter City"
                  id="city"
                  name="city"
                  type="text"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.city}
                  onChange={(e) => handleFieldMapping("city", e.target.value)}
                />
              </Grid>
              <InlineMessage error={formik.errors?.city} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography htmlFor="zipCode">
                  {getBillingZipLabel(formik.values.countryId)}
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <input
                  id="zipCode"
                  name="zipCode"
                  className="form-label form-control"
                  type="text"
                  maxLength={getMaxLength(formik.values.countryId)}
                  placeholder={getBillingZipPlaceholder(
                    formik.values.countryId,
                  )}
                  value={formik.values.zipCode}
                  onChange={(e) => {
                    formik.setFieldValue("dirty", true);
                    const formattedValue = isCountryCanada(
                      formik.values.countryId,
                    )
                      ? formatCanadianPostalCode(e.target.value)
                      : formatUSZipCode(e.target.value);
                    formik.setFieldValue("zipCode", formattedValue);
                    handleFieldMapping("zipCode", formattedValue);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors.zipCode} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Phone Number
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <span
                  style={{
                    padding: "7.5px",
                    border: "1px solid #ccc",
                    backgroundColor: "#f8f9fa",
                    fontSize: "14px",
                  }}
                >
                  +1
                </span>
                <input
                  id="phone"
                  className="form-label form-control"
                  name="phone"
                  placeholder="Enter Phone Number"
                  maxLength={10}
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                  value={formik.values?.phone}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replaceAll(/\D/g, "");
                    formik.setFieldValue("dirty", true);
                    formik.setFieldValue("phone", onlyDigits);
                    handleFieldMapping("phone", onlyDigits);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors?.phone} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Mobile Number
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <span
                  style={{
                    padding: "7.5px",
                    border: "1px solid #ccc",
                    backgroundColor: "#f8f9fa",
                    fontSize: "14px",
                  }}
                >
                  +1
                </span>
                <input
                  id="mobile"
                  className="form-label form-control"
                  name="mobile"
                  placeholder="Enter Mobile Number"
                  maxLength={10}
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                  }}
                  value={formik.values?.mobile}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replaceAll(/\D/g, "");
                    formik.setFieldValue("dirty", true);
                    formik.setFieldValue("mobile", onlyDigits);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors?.mobile} />
            </Grid>
            <Grid item xs={4} container alignItems="center" spacing={0}>
              <Grid
                item
                xs={5.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                <Typography
                  className="agency-name-align-link"
                  style={{ marginRight: "8px" }}
                >
                  Email
                  <MandatoryField />
                </Typography>
              </Grid>
              <Grid
                item
                xs={6.5}
                container
                alignItems="center"
                spacing={0}
                style={{ marginTop: "8px" }}
              >
                {" "}
                <input
                  id="email"
                  name="email"
                  className="form-label form-control"
                  type="email"
                  placeholder="Enter Email"
                  autoComplete="off"
                  style={{
                    flex: 1,
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                  value={formik.values?.email}
                  onChange={(e) => {
                    handleFieldMapping("email", e.target.value);
                  }}
                />
              </Grid>
              <InlineMessage error={formik.errors?.email} />
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} mt={0} fontWeight={700} fontSize={16}>
          Select Content(s) from dropdown to view and/or complete
        </Grid>
        <Grid item xs={12} container mt={2} mb={2}>
          <select
            id="selectSharedForm"
            name="selectSharedForm"
            value={docIndex}
            onChange={(e) => {
              const selectedId = Number(e.target.value);
              fetchReusableLinkContent(selectedId);
            }}
            className="form-control form-select"
          >
            {resultList.map((res) => (
              <option key={res.contentName} value={res.reusableLinkContentId}>
                {res.contentName}
              </option>
            ))}
          </select>
        </Grid>
        <Grid container>
          <Grid item xs={12} className="top-right-actions">
            <button
              type="button"
              name="AddNote"
              className="add-itemz-font"
              data-testid="AddNote"
              onClick={() => setShowAdditionalNotes(true)}
              style={{
                background: "none",
                border: "none",
                padding: 0,
                cursor: "pointer",
              }}
            >
              <h5 style={{ padding: "8px" }}>
                <span>+ Add Notes</span>
              </h5>
            </button>
          </Grid>
        </Grid>
        <Grid item xs={12} m={2} style={{ margin: "50px 0px 10px 0px" }}>
          {result?.typeOfContent === 7 && (
            <AudioPreview selectedDocument={selectedDocument} />
          )}
          {result?.typeOfContent === 10 && (
            <VideoPreview selectedDocument={selectedDocument} />
          )}
          {result.typeOfContent === 11 && result?.webLink && (
            <Grid item xs={12} pt={2}>
              <Typography className="login-para" varient="h5" paragraph>
                Kindly click on the link below to open the document.
              </Typography>
            </Grid>
          )}
          {result?.typeOfContent === 11 && (
            <Grid item xl={12} xs={12} m={2}>
              {result?.webLink ? (
                <Tooltip title={result.webLink}>
                  <Link
                    href={
                      result.webLink.startsWith("http")
                        ? result.webLink
                        : `https://${result.webLink}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open Web Link
                  </Link>
                </Tooltip>
              ) : (
                <Typography color="error">No web link available</Typography>
              )}
            </Grid>
          )}
          {selectedDocument.length > 0 &&
            [1, 3, 4, 5, 6, 8, 9].includes(result?.typeOfContent) && (
              <MemoizedDocumentViewer
                documents={selectedDocument}
                fileType={result?.typeOfContent}
              />
            )}
          {xfdlCurrentJson && (
            <>
              {resultList && (
                <Grid container className="select-share-xfdl" spacing={2}>
                  <Grid item xs={6} mt={-5}>
                    <label style={{ color: "red" }}>
                      Mandatory fields left:{" "}
                      {
                        resultList.find(
                          (x) => x.reusableLinkContentId === docIndex,
                        )?.MandatoryReqFieldCount
                      }
                    </label>
                  </Grid>
                  <Grid item xs={8} mt={-3}>
                    <label
                      htmlFor="sharedForm"
                      style={{
                        color: "red",
                        fontSize: "14px",
                      }}
                    >
                      Total Mandatory fields left:{" "}
                      {totalRemainingMandatoryFields}
                    </label>
                  </Grid>
                </Grid>
              )}
              <XFDLViewer
                document={xfdlCurrentJson}
                fileName={result?.contentName}
                formData={
                  resultList.find((x) => x.reusableLinkContentId === docIndex)
                    ?.formData
                }
                requiredFields={
                  resultList.find((x) => x.reusableLinkContentId === docIndex)
                    ?.requiredFeilds
                }
                saveOrSubmit={saveOrSubmit}
                from="share"
                changeHandler={changeHandler}
                checkBoxHandler={checkBoxHandler}
                isValid={isInValid}
                isSubmitted={isSubmitted}
                checkRequiredFields={checkRequiredFields}
              />
            </>
          )}
        </Grid>
      </Container>
    );
  }
}

export default ReusableLink;
function newFunction_3(res) {
  return (
    <option key={res.contentName} value={res.reusableLinkContentId}>
      {res.contentName}
    </option>
  );
}

function filteredResultList(item, x, allAdditionalNotes) {
  return (
    item.reusableLinkContentId === x.reusableLinkContentId ||
    !allAdditionalNotes.some(
      (y) => y.reusableLinkContentId === x.reusableLinkContentId,
    )
  );
}

function newFunction_2(setAllAdditionalNotes, index) {
  setAllAdditionalNotes((addNotes) => {
    return [...addNotes.filter((x, i) => i !== index)];
  });
}

function newFunction_1(item, pattern, value) {
  return () => {
    item.formData.forEach((f) => {
      if (f.key.startsWith(pattern)) {
        f.value = value;
      }
    });
  };
}

function newFunction(pattern, item) {
  const fieldNames = [];

  const addMatchingFields = (fields) => {
    fields.forEach((field) => {
      if (field.Name.startsWith(pattern)) {
        fieldNames.push(field.Name);
      }
    });
  };

  item.xfdlJson?.Canvas?.forEach((canvas) => {
    if (canvas.TextBoxes) addMatchingFields(canvas.TextBoxes);
    if (canvas.CheckBoxes) addMatchingFields(canvas.CheckBoxes);
  });

  return fieldNames;
}

/*istanbul ignore next */
function formatUSZipCode(value) {
  value = value.replaceAll(/\D/g, "");
  if (value.length > 5) {
    value = value.slice(0, 5) + "-" + value.slice(5, 9);
  }
  return value.slice(0, 10);
}
/*istanbul ignore next */
function formatCanadianPostalCode(value) {
  value = value.replaceAll(/\s/g, "").toUpperCase();
  const validFirstLetter = /^[ABCEGHJKLMNPRSTVXY]/;
  if (!validFirstLetter.test(value.charAt(0))) {
    return "";
  }
  value = value.replaceAll(/[^A-Z0-9]/g, "").slice(0, 6);
  if (value.length > 3) {
    value = value.slice(0, 3) + " " + value.slice(3);
  }
  return value;
}
